import React from "react";

function PrivacyPolicy() {
  return (
    <div className="privacy-policy container">
      <h1>Privacy Policy</h1>
      <p className="last-updated">Last updated: Feb 15, 2025</p>
      <section>
        <h2>1. Introduction</h2>
        <p>
          This Privacy Policy describes our policies regarding the use of Geekun
          and explains how we handle any information that might be indirectly
          collected through its use.
        </p>
        <p>
          We do not collect any personal data from users. You can use the app
          entirely anonymously. There is no registration process.
        </p>
      </section>
      <section>
        <h2>2. Interpretation and Definitions</h2>
        <p>
          The words of which the initial letter is capitalized have meanings
          defined under the following conditions. The following definitions
          shall have the same meaning regardless of whether they appear in
          singular or in plural.
        </p>
      </section>
      <section>
        <h2>3. Definitions</h2>
        <p>For the purposes of this Privacy Policy:</p>
        <ul>
          <li>
            <strong>Account</strong> means a unique account created for You to
            access our Service or parts of our Service.
          </li>
          <li>
            <strong>Affiliate</strong> means an entity that controls, is
            controlled by or is under common control with a party, where
            "control" means ownership of 50% or more of the shares, equity
            interest or other securities entitled to vote for election of
            directors or other managing authority.
          </li>
          <li>
            <strong>Application</strong> refers to Geekun, the software program
            provided by the Company.
          </li>
          <li>
            <strong>Company</strong> (referred to as either "the Company", "We",
            "Us" or "Our" in this Agreement) refers to Geekun.
          </li>
          <li>
            <strong>Device</strong> means any device that can access the Service
            such as a computer, a cellphone or a digital tablet.
          </li>
          <li>
            <strong>Personal Data</strong> is any information that relates to an
            identified or identifiable individual.
          </li>
          <li>
            <strong>Service</strong> refers to the Application.
          </li>
          <li>
            <strong>Service Provider</strong> means any natural or legal person
            who processes the data on behalf of the Company. It refers to
            third-party companies or individuals employed by the Company to
            facilitate the Service, to provide the Service on behalf of the
            Company, to perform services related to the Service or to assist the
            Company in analyzing how the Service is used.
          </li>
          <li>
            <strong>Usage Data</strong> refers to data collected automatically,
            either generated by the use of the Service or from the Service
            infrastructure itself (for example, the duration of a page visit).
          </li>
          <li>
            <strong>You</strong> means the individual accessing or using the
            Service, or the company, or other legal entity on behalf of which
            such individual is accessing or using the Service, as applicable.
          </li>
        </ul>
      </section>
      <section>
        <h2>4. We Do Not Collect Personal Data</h2>
        <p>
          Geekun does not collect any personal data from users. You can use the
          app entirely anonymously. There is no registration process.
        </p>
      </section>
      <section>
        <h2>5. Third-Party Data Collection</h2>
        <p>
          While Geekun does not collect personal data, third-party ad networks
          and analytics services may collect and use certain data from your
          device, including the Advertising ID, location data, and usage
          patterns, for the purposes of delivering targeted advertisements,
          measuring ad performance, and analyzing user interactions with the
          app. We encourage you to review their privacy policies for detailed
          information on their data practices:
        </p>
        <ul>
          <li>
            <a
              href="https://support.google.com/admob/answer/6128543?hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              AdMob
            </a>
          </li>
          <li>
            <a
              href="https://www.applovin.com/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              AppLovin
            </a>
          </li>
          <li>
            <a
              href="https://mixpanel.com/legal/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mixpanel
            </a>
          </li>
        </ul>
      </section>

      <section>
        <h2>6. Advertising and GDPR</h2>
        <p>
          Geekun displays advertisements within the app. These ads are delivered
          by third-party ad networks, including AdMob and AppLovin, which may
          collect certain information about your device and browsing habits in
          accordance with their own privacy policies. We recommend that you
          review the privacy policies of these ad networks to understand how
          they collect, use, and share your data.
        </p>
        <p>
          By using Geekun, you acknowledge that these third-party ad networks
          may use your data to provide targeted advertisements and improve ad
          performance.
        </p>
        <p>
          Links to privacy policies of third-party service providers used by the
          app:
        </p>
        <ul>
          <li>
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Play Services
            </a>
          </li>
          <li>
            <a
              href="https://support.google.com/admob/answer/6128543?hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              AdMob
            </a>
          </li>
          <li>
            <a
              href="https://www.applovin.com/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              AppLovin
            </a>
          </li>
        </ul>
        <p>
          <br />
          Please note that Geekun does not control these third-party networks
          and their data practices. We encourage users to familiarize themselves
          with the privacy policies of any third-party services they engage
          with.
        </p>
      </section>

      <section>
        <h2>7. General Data Protection Regulation (GDPR)</h2>
        <p>
          As Geekun operates globally, we are committed to complying with the
          General Data Protection Regulation (GDPR) for users in the European
          Economic Area (EEA). Since we don't collect personal data, the GDPR's
          data subject rights (access, rectification, erasure, restriction of
          processing, portability, and objection) are not directly applicable.
        </p>
      </section>

      <section>
        <h2>8. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us
          at:
        </p>
        <p>Email: geekun.business@gmail.com</p>
      </section>
      <section>
        <h2>9. Changes to this Privacy Policy</h2>
        <p>
          We may update our Privacy Policy from time to time. We will notify you
          of any changes by posting the new Privacy Policy on this page.
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
